<template>
  <header>
    <div class="wrap nav">
      <router-link class="logo" to="/">
        <span class="my">my</span><span class="vps">VPS</span>
      </router-link>
      <ul :class="{ open: menuOpen }">
        <li><a href="/#features" @click="closeMenu">Возможности</a></li>
        <li><a href="/#servers" @click="closeMenu">Серверы</a></li>
        <li><a href="/#pricing" @click="closeMenu">Тарифы</a></li>
        <li><a href="/#specs" @click="closeMenu">Технологии</a></li>
        <li><a href="/#faq" @click="closeMenu">FAQ</a></li>
      </ul>
      <div class="navright">
        <a class="navcta" :href="cabinetUrl">Личный кабинет</a>
        <button class="burger" type="button" aria-label="Меню" :aria-expanded="menuOpen" @click="menuOpen = !menuOpen">☰</button>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { cabinetUrl } from '../cabinetUrls'

const menuOpen = ref(false)

const closeMenu = () => {
  menuOpen.value = false
}

const onResize = () => {
  if (window.innerWidth > 980) menuOpen.value = false
}

onMounted(() => window.addEventListener('resize', onResize))
onUnmounted(() => window.removeEventListener('resize', onResize))
</script>
